<template>
  <div class="text-container">
    <slot></slot>
  </div>
</template>

<script setup>
// This is a minimal component that doesn't need any reactive state or methods
// The Composition API version is essentially the same as the Options API version
// but using the modern setup syntax
</script>

<style scoped>
.text-container {
  max-width: 794px;
  margin: 0 auto;
}
</style>
